import { render } from "./ApproveRequests.vue?vue&type=template&id=84556ec0"
import script from "./ApproveRequests.vue?vue&type=script&lang=js"
export * from "./ApproveRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__